export type TemaPreferido = "light" | "dark";

const STORAGE_KEY = "layoutTheme";

export const guardarTemaLocal = (tema: TemaPreferido) => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, tema);
  } catch {
    // ignorar
  }
};

export const obtenerTemaLocal = (): TemaPreferido | null => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const valor = localStorage.getItem(STORAGE_KEY);
    if (valor === "light" || valor === "dark") {
      return valor;
    }
    return null;
  } catch {
    return null;
  }
};

export const limpiarTemaLocal = () => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignorar
  }
};
